module.exports = __webpack_public_path__ + "static/media/sakura_default102559639773fb94518407c27a45403e.webp";